import { render, staticRenderFns } from "./PerfectMoney.html?vue&type=template&id=4161265c&scoped=true&"
import script from "./PerfectMoney.js?vue&type=script&lang=js&"
export * from "./PerfectMoney.js?vue&type=script&lang=js&"
import style0 from "./PerfectMoney.scss?vue&type=style&index=0&id=4161265c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161265c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VIcon,VRow})
